import React, { Fragment, useEffect, useState } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FcardBank from "../../components/FcardBank/FcardBank";
import FSmallCreditCard from "../../components/FSmallCreditCard/FSmallCreditCard";
import { useCards } from "../../hooks/useCards";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Swal from "sweetalert2";

const CardsScreen = ({ param }) => {
  const { getCard, cards, deleteCard } = useCards();

  const route = useNavigate();

  useEffect(() => {
    getCard();
  }, []);

  const nextScreen = async (id) => {
    const response = await deleteCard(id);
    if (response == true) {
      getCard();
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: 'No pudimos procesar tu solicitud en este momento, por favor intenta mas tarde',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };


  return (
    <>
      <FBannerTitleButton
        title="Agrega tu método de pago"
        imageUrl={require("../../components/assets/images/credit_card.png")}
        titleButton={
          <Fbutton
            value="Añadir tarjeta"
            onClick={() => {
              route("/CreateCardScreen");
            }}
          />
        }
      />

      <FContainer>
        <div className="border-black w-full xs:w-[350px]">
          <FSmallCreditCard
            arrayGroups={cards}
            onDeleteEmail={(email) => {
              Swal.fire({
                showCloseButton: true,
                title: "Eliminar tarjeta",
                text: "¿Está seguro que desea eliminar esta tarjeta?",
                imageUrl: require("../../components/assets/images/pregunta.png"),
                imageWidth: 150,
                imageHeight: 150,
                imageAlt: "Custom image",
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  nextScreen(email.id);
                }
              });
            }}
          />
        </div>
      </FContainer>
    </>
  );
};

export default CardsScreen;
